module.exports = "https://milano-network.servercdn.it/static/fonts/FuturaPT-Book.eot?ba7c7f34c672e9f406dd97a9a8f33dec";